import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import ChatbotDashboard from "./chatgrid";
import RecentActivity from "./recentActivity";

const CategoryTabs: React.FC = () => {
  return (
    <Flex flexDirection="column" h="100%" flex="1">
      <Box flex="1" overflow="auto" w="100%">
        <ChatbotDashboard />
        <RecentActivity />
      </Box>
    </Flex>
  );
};

export default CategoryTabs;
